/**
 * Get formatted date.
 * @param {Date} date
 * @param {Object} [options]
 * @returns {String} Formatted date.
 */
const getFormattedDate = (date, options = {}) => {
	if (date === null) {
		return ''
	}

	return new Intl.DateTimeFormat('sk-SK', options).format(new Date(date))
}

export default getFormattedDate
